import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../notes/button/button.module';
import { IconModule } from '../../notes/icon/icon.module';
import { ModalModule } from '../../notes/modal/modal.module';
import { LinkModule } from '../link/link.module';
import { TileGridComponent } from './tile-grid.component';

@NgModule({
  declarations: [TileGridComponent],
  imports: [CommonModule, LinkModule, IconModule, ModalModule, ButtonModule],
  exports: [TileGridComponent],
})
export class TileGridModule {}
